// LocalStorageService.js
const LocalStorageService = (function () {
  var _service;
  const authorizationData = 'ls.authorizationData';

  function _getService() {
    if (!_service) {
      _service = this;
      return _service
    }
    return _service
  }
  function _setToken(tokenObj) {
    localStorage.setItem('ls.authorizationData', JSON.stringify(tokenObj));
  }
  function _getAccessToken() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    try {
      if (authorizationData)
        return JSON.parse(authorizationData).access_token;
    } catch (err) {
      localStorage.removeItem('ls.authorizationData');
    }

  }
  /* the whole stored token answer (access_token, refresh_token, ".expires", ...), or null */
  function _getAuthorizationData() {
    try {
      return JSON.parse(localStorage.getItem("ls.authorizationData")) || null;
    } catch (err) {
      return null;
    }
  }
  function _getRefreshToken() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    if (authorizationData)
      return JSON.parse(authorizationData).refresh_token;
  }
  function _clearToken() {
    localStorage.removeItem('ls.authorizationData')
  }
  function _getRoles() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    if (authorizationData)
      return JSON.parse(authorizationData).roles
  }
  function _getUserName() {
    try {
      const authorizationData = localStorage.getItem("ls.authorizationData")

      if (authorizationData)
        return JSON.parse(authorizationData).userName
    } catch (err) {
      localStorage.removeItem('ls.authorizationData');
    }
  }
  /**
   * 
   * @param {Object} data 
   */
  const _setPreference = (data) => {
    localStorage.setItem('ls.preference', JSON.stringify(data));
  }
  const _getPreference = () => JSON.parse(localStorage.getItem('ls.preference'));
  const _setWorkspaceId = (baseServer, wsId) => {
    localStorage.setItem(`ls.wsId.${baseServer}`, wsId);
  }
  const _getWorkspaceId = (baseServer) => localStorage.getItem(`ls.wsId.${baseServer}`);
  const _removeWorkspaceId = (baseServer) => {
    localStorage.removeItem(`ls.wsId.${baseServer}`);
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {Object} data 
   */
  const _setWorkspace = (baseServer, data) => {
    localStorage.setItem(`ls.workspaceData.${baseServer}.${data.id}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {number} id 
   * @returns 
   */
  const _getWorkspace = (baseServer, id) => JSON.parse(localStorage.getItem(`ls.workspaceData.${baseServer}.${id}`));
  /**
   * 
   * @param {string} baseServer 
   * @param {string|number} id
   */
  const _clearWorkspaceById = (baseServer, id) => {
    localStorage.removeItem(`ls.workspaceData.${baseServer}.${id}`);
  }
  /**
   *
   * @param {string} baseServer
   */
  const _clearWorkspace = (baseServer) => {
    Object.keys(localStorage).filter((key) =>
      key && key.indexOf(`ls.workspaceData.${baseServer}`) !== -1
    )
      .forEach(x => {
        localStorage.removeItem(x);
      });
    /* legacy */
    localStorage.removeItem('ls.workspaceData');
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {Object} data 
   */
  const _setWebData = (baseServer, data) => {
    localStorage.setItem(`ls.webData.${baseServer}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {string} baseServer 
   */
  const _getWebData = (baseServer) => {
    return JSON.parse(localStorage.getItem(`ls.webData.${baseServer}`));
  }
  /**
   * 
   * @param {string} baseServer 
   */
  const _clearWebData = (baseServer) => {
    localStorage.removeItem(`ls.webData.${baseServer}`);
  }
  /**
   * 
   * @param {string|number} moduleId 
   * @param {string|number} listingId 
   * @returns 
   */
  const _getModuleListingPreference = (moduleId, listingId) => {
    const res = localStorage.getItem(`lv.${moduleId}.${listingId}`);
    if (res) {
      try {
        return JSON.parse(res);
      } catch(err) {
        return { type: res };
      }
    }
  }
  /**
   * 
   * @param {string|number} moduleId 
   * @param {string|number} listingId 
   */
  const _setModuleListingPreference = (moduleId, listingId, data) => {
    localStorage.setItem(`lv.${moduleId}.${listingId}`, JSON.stringify(data));
  }
  /**
   * Per-user column freeze for a table field on one form (SS05971).
   * Scoped by workspace rather than module because the table components have no module
   * identity — only the field id, which is a stable nanoID. Scoped by form as well,
   * because the same field renders on both the entry view form and every activity form,
   * and a freeze on one must not follow the user to the others.
   * @param {string|number} vectorId
   * @param {string} formKey activity id, or 'view' for the entry view form
   * @param {string|number} fieldId
   * @returns
   */
  const _getTableFreezePreference = (vectorId, formKey, fieldId) => {
    const res = localStorage.getItem(`tf.${vectorId}.${formKey}.${fieldId}`);
    if (res) {
      try {
        return JSON.parse(res);
      } catch(err) {
        return undefined;
      }
    }
  }
  /**
   *
   * @param {string|number} vectorId
   * @param {string} formKey activity id, or 'view' for the entry view form
   * @param {string|number} fieldId
   * @param {Object} data
   */
  const _setTableFreezePreference = (vectorId, formKey, fieldId, data) => {
    localStorage.setItem(`tf.${vectorId}.${formKey}.${fieldId}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {string|number} wsId 
   * @returns 
   */
  const _getStudioPreference = (baseServer, wsId) => {
    return JSON.parse(localStorage.getItem(`ls.studio.${baseServer}.${wsId}`));
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {string|number} wsId 
   * @param {Object} data 
   */
  const _setStudioPreference = (baseServer, wsId, data) => {
    localStorage.setItem(`ls.studio.${baseServer}.${wsId}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {server} baseServer 
   * @param {string} data 
   */
  const _setLiteMode = (baseServer, data) => {
    localStorage.setItem(`ls.liteMode.${baseServer}`, JSON.stringify(data));
  }
  /**
   *
   * @param {string} baseServer
   */
  const _getLiteMode = (baseServer) => {
    return JSON.parse(localStorage.getItem(`ls.liteMode.${baseServer}`));
  }
  /**
   * Demo mode toggle — hides all alpha/beta/development features. Persisted per server.
   * @param {string} baseServer
   * @param {boolean} data
   */
  const _setDemoMode = (baseServer, data) => {
    localStorage.setItem(`ls.demoMode.${baseServer}`, JSON.stringify(Boolean(data)));
  }
  /**
   *
   * @param {string} baseServer
   */
  const _getDemoMode = (baseServer) => {
    return JSON.parse(localStorage.getItem(`ls.demoMode.${baseServer}`));
  }
  /**
   * Snapped width for a resizable layout panel (e.g. detail view's list/history columns).
   * Global rather than per-module: the presets a panel snaps to are the same everywhere it
   * appears, so the chosen width should follow the user across modules too.
   * @param {string} panelId
   * @returns {number|undefined}
   */
  const _getPanelWidthPreference = (panelId) => {
    const width = Number(localStorage.getItem(`pw.${panelId}`));
    return Number.isFinite(width) && width > 0 ? width : undefined;
  }
  /**
   *
   * @param {string} panelId
   * @param {number} width
   */
  const _setPanelWidthPreference = (panelId, width) => {
    localStorage.setItem(`pw.${panelId}`, String(width));
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    getAuthorizationData: _getAuthorizationData,
    clearToken: _clearToken,
    getRoles: _getRoles,
    getUserName: _getUserName,
    setPreference: _setPreference,
    getPreference: _getPreference,
    setWorkspaceId: _setWorkspaceId,
    getWorkspaceId: _getWorkspaceId,
    removeWorkspaceId: _removeWorkspaceId,
    setWorkspace: _setWorkspace,
    getWorkspace: _getWorkspace,
    clearWorkspaceById: _clearWorkspaceById,
    clearWorkspace: _clearWorkspace,
    setWebData: _setWebData,
    getWebData: _getWebData,
    clearWebData: _clearWebData,
    getModuleListingPreference: _getModuleListingPreference,
    setModuleListingPreference: _setModuleListingPreference,
    getTableFreezePreference: _getTableFreezePreference,
    setTableFreezePreference: _setTableFreezePreference,
    getStudioPreference: _getStudioPreference,
    setStudioPreference: _setStudioPreference,
    setLiteMode: _setLiteMode,
    getLiteMode: _getLiteMode,
    setDemoMode: _setDemoMode,
    getDemoMode: _getDemoMode,
    getPanelWidthPreference: _getPanelWidthPreference,
    setPanelWidthPreference: _setPanelWidthPreference,
  }
})();

export default LocalStorageService;
